import React from "react";
import SensorBase from "./SensorBase";

const FIELD = "airHumidity";
const UNIT = "%";

const AirHumidity: React.FC = () => {
  return (
    <SensorBase field={FIELD} unit={UNIT}></SensorBase>
  );
};

export default AirHumidity;